function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((e = e || self).ReactTable = {}, e.React);
}(this, function (e, t) {
  "use strict";

  function n(e, t, n, o, r, i, u) {
    try {
      var l = e[i](u),
        s = l.value;
    } catch (e) {
      return void n(e);
    }
    l.done ? t(s) : Promise.resolve(s).then(o, r);
  }
  function o(e) {
    return function () {
      var t = this,
        o = arguments;
      return new Promise(function (r, i) {
        var u = e.apply(t, o);
        function l(e) {
          n(u, r, i, l, s, "next", e);
        }
        function s(e) {
          n(u, r, i, l, s, "throw", e);
        }
        l(void 0);
      });
    };
  }
  function r() {
    return (r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }
      return e;
    }).apply(this, arguments);
  }
  function i(e, t) {
    if (null == e) return {};
    var n,
      o,
      r = {},
      i = Object.keys(e);
    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }
    return r;
  }
  function u(e) {
    var t = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var o = n.call(e, t || "default");
        if ("object" != typeof o) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : String(t);
  }
  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
  var l = {
      init: "init"
    },
    s = function s(e) {
      var t = e.value;
      return void 0 === t ? "" : t;
    },
    a = function a() {
      return t.createElement(t.Fragment, null, " ");
    },
    c = {
      Cell: s,
      width: 150,
      minWidth: 0,
      maxWidth: Number.MAX_SAFE_INTEGER
    };
  function d() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }
    return t.reduce(function (e, t) {
      var n = t.style,
        o = t.className;
      return e = r({}, e, {}, i(t, ["style", "className"])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
    }, {});
  }
  var f = function f(e, t) {
      return void 0 === t && (t = {}), function (n) {
        return void 0 === n && (n = {}), [].concat(e, [n]).reduce(function (e, o) {
          return function e(t, n, o) {
            return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [t].concat(n)) : d(t, n);
          }(e, o, r({}, t, {
            userProps: n
          }));
        }, {});
      };
    },
    p = function p(e, t, n, o) {
      return void 0 === n && (n = {}), e.reduce(function (e, t) {
        return t(e, n);
      }, t);
    },
    g = function g(e, t, n) {
      return void 0 === n && (n = {}), e.forEach(function (e) {
        e(t, n);
      });
    };
  function v(e, t, n, o) {
    e.findIndex(function (e) {
      return e.pluginName === n;
    });
    t.forEach(function (t) {
      e.findIndex(function (e) {
        return e.pluginName === t;
      });
    });
  }
  function m(e, t) {
    return "function" == typeof e ? e(t) : e;
  }
  function h(e) {
    var n = t.useRef();
    return n.current = e, t.useCallback(function () {
      return n.current;
    }, []);
  }
  var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
  function w(e, n) {
    var o = t.useRef(!1);
    y(function () {
      o.current && e(), o.current = !0;
    }, n);
  }
  function R(e, t, n) {
    return void 0 === n && (n = {}), function (o, i) {
      void 0 === i && (i = {});
      var u = "string" == typeof o ? t[o] : o;
      if (void 0 === u) throw console.info(t), new Error("Renderer Error ☝️");
      return b(u, r({}, e, {
        column: t
      }, n, {}, i));
    };
  }
  function b(e, n) {
    return function (e) {
      return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
      var t;
    }(o = e) || "function" == typeof o || function (e) {
      return "object" == typeof e && "symbol" == typeof e.$$typeof && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
    }(o) ? t.createElement(e, n) : e;
    var o;
  }
  function S(e, t, n) {
    return void 0 === n && (n = 0), e.map(function (e) {
      return x(e = r({}, e, {
        parent: t,
        depth: n
      })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
    });
  }
  function C(e) {
    return G(e, "columns");
  }
  function x(e) {
    var t = e.id,
      n = e.accessor,
      o = e.Header;
    if ("string" == typeof n) {
      t = t || n;
      var r = n.split(".");
      n = function n(e) {
        return function (e, t, n) {
          if (!t) return e;
          var o,
            r = "function" == typeof t ? t : JSON.stringify(t),
            i = E.get(r) || function () {
              var e = function (e) {
                return function e(t, n) {
                  void 0 === n && (n = []);
                  if (Array.isArray(t)) for (var o = 0; o < t.length; o += 1) {
                    e(t[o], n);
                  } else n.push(t);
                  return n;
                }(e).map(function (e) {
                  return String(e).replace(".", "_");
                }).join(".").replace(T, ".").replace(O, "").split(".");
              }(t);
              return E.set(r, e), e;
            }();
          try {
            o = i.reduce(function (e, t) {
              return e[t];
            }, e);
          } catch (e) {}
          return void 0 !== o ? o : n;
        }(e, r);
      };
    }
    if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
    if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
    return Object.assign(e, {
      id: t,
      accessor: n
    }), e;
  }
  function P(e, t) {
    if (!t) throw new Error();
    return Object.assign(e, r({
      Header: a,
      Footer: a
    }, c, {}, t, {}, e)), Object.assign(e, {
      originalWidth: e.width
    }), e;
  }
  function B(e, t, n) {
    void 0 === n && (n = function n() {
      return {};
    });
    for (var o = [], i = e, u = 0, l = function l() {
        return u++;
      }, s = function s() {
        var e = {
            headers: []
          },
          u = [],
          s = i.some(function (e) {
            return e.parent;
          });
        i.forEach(function (o) {
          var i,
            a = [].concat(u).reverse()[0];
          if (s) {
            if (o.parent) i = r({}, o.parent, {
              originalId: o.parent.id,
              id: o.parent.id + "_" + l(),
              headers: [o]
            }, n(o));else i = P(r({
              originalId: o.id + "_placeholder",
              id: o.id + "_placeholder_" + l(),
              placeholderOf: o,
              headers: [o]
            }, n(o)), t);
            a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
          }
          e.headers.push(o);
        }), o.push(e), i = u;
      }; i.length;) {
      s();
    }
    return o.reverse();
  }
  var E = new Map();
  function I() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }
    for (var o = 0; o < t.length; o += 1) {
      if (void 0 !== t[o]) return t[o];
    }
  }
  function F(e) {
    if ("function" == typeof e) return e;
  }
  function G(e, t) {
    var n = [];
    return function e(o) {
      o.forEach(function (o) {
        o[t] ? e(o[t]) : n.push(o);
      });
    }(e), n;
  }
  function A(e, t) {
    var n = t.manualExpandedKey,
      o = t.expanded,
      r = t.expandSubRows,
      i = void 0 === r || r,
      u = [];
    return e.forEach(function (e) {
      return function e(t, r) {
        void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function (t) {
          return e(t, i);
        });
      }(e);
    }), u;
  }
  function k(e, t, n) {
    return F(e) || t[e] || n[e] || n.text;
  }
  function H(e, t, n) {
    return e ? e(t, n) : void 0 === t;
  }
  function W() {
    throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
  }
  var z = null;
  var T = /\[/g,
    O = /\]/g;
  var M = function M(e) {
      return r({
        role: "table"
      }, e);
    },
    j = function j(e) {
      return r({
        role: "rowgroup"
      }, e);
    },
    L = function L(e, t) {
      var n = t.column;
      return r({
        key: "header_" + n.id,
        colSpan: n.totalVisibleHeaderCount,
        role: "columnheader"
      }, e);
    },
    N = function N(e, t) {
      var n = t.column;
      return r({
        key: "footer_" + n.id,
        colSpan: n.totalVisibleHeaderCount
      }, e);
    },
    D = function D(e, t) {
      return r({
        key: "headerGroup_" + t.index,
        role: "row"
      }, e);
    },
    V = function V(e, t) {
      return r({
        key: "footerGroup_" + t.index
      }, e);
    },
    _ = function _(e, t) {
      return r({
        key: "row_" + t.row.id,
        role: "row"
      }, e);
    },
    X = function X(e, t) {
      var n = t.cell;
      return r({
        key: "cell_" + n.row.id + "_" + n.column.id,
        role: "cell"
      }, e);
    };
  function q() {
    return {
      useOptions: [],
      stateReducers: [],
      useControlledState: [],
      columns: [],
      columnsDeps: [],
      allColumns: [],
      allColumnsDeps: [],
      accessValue: [],
      materializedColumns: [],
      materializedColumnsDeps: [],
      useInstanceAfterData: [],
      visibleColumns: [],
      visibleColumnsDeps: [],
      headerGroups: [],
      headerGroupsDeps: [],
      useInstanceBeforeDimensions: [],
      useInstance: [],
      prepareRow: [],
      getTableProps: [M],
      getTableBodyProps: [j],
      getHeaderGroupProps: [D],
      getFooterGroupProps: [V],
      getHeaderProps: [L],
      getFooterProps: [N],
      getRowProps: [_],
      getCellProps: [X],
      useFinalInstance: []
    };
  }
  l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
  var K = function K(e) {
    e.getToggleHiddenProps = [U], e.getToggleHideAllColumnsProps = [$], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function (e, t) {
      var n = t.instance;
      return [].concat(e, [n.state.hiddenColumns]);
    }), e.useInstance.push(Q);
  };
  K.pluginName = "useColumnVisibility";
  var U = function U(e, t) {
      var n = t.column;
      return [e, {
        onChange: function onChange(e) {
          n.toggleHidden(!e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isVisible,
        title: "Toggle Column Visible"
      }];
    },
    $ = function $(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function onChange(e) {
          n.toggleHideAllColumns(!e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
        title: "Toggle All Columns Hidden",
        indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
      }];
    };
  function J(e, t, n, o) {
    if (t.type === l.init) return r({
      hiddenColumns: []
    }, e);
    if (t.type === l.resetHiddenColumns) return r({}, e, {
      hiddenColumns: o.initialState.hiddenColumns || []
    });
    if (t.type === l.toggleHideColumn) {
      var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [t.columnId]) : e.hiddenColumns.filter(function (e) {
        return e !== t.columnId;
      });
      return r({}, e, {
        hiddenColumns: i
      });
    }
    return t.type === l.setHiddenColumns ? r({}, e, {
      hiddenColumns: m(t.value, e.hiddenColumns)
    }) : t.type === l.toggleHideAllColumns ? r({}, e, {
      hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function (e) {
        return e.id;
      }) : []
    }) : void 0;
  }
  function Y(e) {
    var n = e.headers,
      o = e.state.hiddenColumns;
    t.useRef(!1).current;
    var r = 0;
    n.forEach(function (e) {
      return r += function e(t, n) {
        t.isVisible = n && !o.includes(t.id);
        var r = 0;
        return t.headers && t.headers.length ? t.headers.forEach(function (n) {
          return r += e(n, t.isVisible);
        }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
      }(e, !0);
    });
  }
  function Q(e) {
    var n = e.columns,
      o = e.flatHeaders,
      r = e.dispatch,
      i = e.allColumns,
      u = e.getHooks,
      s = e.state.hiddenColumns,
      a = e.autoResetHiddenColumns,
      c = void 0 === a || a,
      d = h(e),
      p = i.length === s.length,
      g = t.useCallback(function (e, t) {
        return r({
          type: l.toggleHideColumn,
          columnId: e,
          value: t
        });
      }, [r]),
      v = t.useCallback(function (e) {
        return r({
          type: l.setHiddenColumns,
          value: e
        });
      }, [r]),
      m = t.useCallback(function (e) {
        return r({
          type: l.toggleHideAllColumns,
          value: e
        });
      }, [r]),
      y = f(u().getToggleHideAllColumnsProps, {
        instance: d()
      });
    o.forEach(function (e) {
      e.toggleHidden = function (t) {
        r({
          type: l.toggleHideColumn,
          columnId: e.id,
          value: t
        });
      }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
        instance: d(),
        column: e
      });
    });
    var R = h(c);
    w(function () {
      R() && r({
        type: l.resetHiddenColumns
      });
    }, [r, n]), Object.assign(e, {
      allColumnsHidden: p,
      toggleHideColumn: g,
      setHiddenColumns: v,
      toggleHideAllColumns: m,
      getToggleHideAllColumnsProps: y
    });
  }
  var Z = {},
    ee = {},
    te = function te(e, t, n) {
      return e;
    },
    ne = function ne(e, t) {
      return e.subRows || [];
    },
    oe = function oe(e, t, n) {
      return "" + (n ? [n.id, t].join(".") : t);
    },
    re = function re(e) {
      return e;
    };
  function ie(e) {
    var t = e.initialState,
      n = void 0 === t ? Z : t,
      o = e.defaultColumn,
      u = void 0 === o ? ee : o,
      l = e.getSubRows,
      s = void 0 === l ? ne : l,
      a = e.getRowId,
      c = void 0 === a ? oe : a,
      d = e.stateReducer,
      f = void 0 === d ? te : d,
      p = e.useControlledState,
      g = void 0 === p ? re : p;
    return r({}, i(e, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), {
      initialState: n,
      defaultColumn: u,
      getSubRows: s,
      getRowId: c,
      stateReducer: f,
      useControlledState: g
    });
  }
  function ue(e, t) {
    void 0 === t && (t = 0);
    var n = 0,
      o = 0,
      r = 0,
      i = 0;
    return e.forEach(function (e) {
      var u = e.headers;
      if (e.totalLeft = t, u && u.length) {
        var l = ue(u, t),
          s = l[0],
          a = l[1],
          c = l[2],
          d = l[3];
        e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
      } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
      e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
    }), [n, o, r, i];
  }
  function le(e) {
    var t = e.data,
      n = e.rows,
      o = e.flatRows,
      r = e.rowsById,
      i = e.column,
      u = e.getRowId,
      l = e.getSubRows,
      s = e.accessValueHooks,
      a = e.getInstance;
    t.forEach(function (e, c) {
      return function e(n, c, d, f, g) {
        void 0 === d && (d = 0);
        var v = n,
          m = u(n, c, f),
          h = r[m];
        if (h) h.subRows && h.originalSubRows.forEach(function (t, n) {
          return e(t, n, d + 1, h);
        });else if ((h = {
          id: m,
          original: v,
          index: c,
          depth: d,
          cells: [{}]
        }).cells.map = W, h.cells.filter = W, h.cells.forEach = W, h.cells[0].getCellProps = W, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
          var y = [];
          h.originalSubRows.forEach(function (t, n) {
            return e(t, n, d + 1, h, y);
          }), h.subRows = y;
        }
        i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
          row: h,
          column: i,
          instance: a()
        });
      }(e, c, 0, void 0, n);
    });
  }
  l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
  var se = function se(e) {
    e.getToggleAllRowsExpandedProps = [ae], e.getToggleRowExpandedProps = [ce], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
  };
  se.pluginName = "useExpanded";
  var ae = function ae(e, t) {
      var n = t.instance;
      return [e, {
        onClick: function onClick(e) {
          n.toggleAllRowsExpanded();
        },
        style: {
          cursor: "pointer"
        },
        title: "Toggle All Rows Expanded"
      }];
    },
    ce = function ce(e, t) {
      var n = t.row;
      return [e, {
        onClick: function onClick() {
          n.toggleRowExpanded();
        },
        style: {
          cursor: "pointer"
        },
        title: "Toggle Row Expanded"
      }];
    };
  function de(e, t, n, o) {
    if (t.type === l.init) return r({
      expanded: {}
    }, e);
    if (t.type === l.resetExpanded) return r({}, e, {
      expanded: o.initialState.expanded || {}
    });
    if (t.type === l.toggleAllRowsExpanded) {
      var s = t.value,
        a = o.rowsById,
        c = Object.keys(a).length === Object.keys(e.expanded).length;
      if (void 0 !== s ? s : !c) {
        var d = {};
        return Object.keys(a).forEach(function (e) {
          d[e] = !0;
        }), r({}, e, {
          expanded: d
        });
      }
      return r({}, e, {
        expanded: {}
      });
    }
    if (t.type === l.toggleRowExpanded) {
      var f,
        p = t.id,
        g = t.value,
        v = e.expanded[p],
        m = void 0 !== g ? g : !v;
      if (!v && m) return r({}, e, {
        expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
      });
      if (v && !m) {
        var h = e.expanded;
        h[p];
        return r({}, e, {
          expanded: i(h, [p].map(u))
        });
      }
      return e;
    }
  }
  function fe(e) {
    var n = e.data,
      o = e.rows,
      r = e.rowsById,
      i = e.manualExpandedKey,
      u = void 0 === i ? "expanded" : i,
      s = e.paginateExpandedRows,
      a = void 0 === s || s,
      c = e.expandSubRows,
      d = void 0 === c || c,
      p = e.autoResetExpanded,
      g = void 0 === p || p,
      m = e.getHooks,
      y = e.plugins,
      R = e.state.expanded,
      b = e.dispatch;
    v(y, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
    var S = h(g),
      C = Boolean(Object.keys(r).length && Object.keys(R).length);
    C && Object.keys(r).some(function (e) {
      return !R[e];
    }) && (C = !1), w(function () {
      S() && b({
        type: l.resetExpanded
      });
    }, [b, n]);
    var x = t.useCallback(function (e, t) {
        b({
          type: l.toggleRowExpanded,
          id: e,
          value: t
        });
      }, [b]),
      P = t.useCallback(function (e) {
        return b({
          type: l.toggleAllRowsExpanded,
          value: e
        });
      }, [b]),
      B = t.useMemo(function () {
        return a ? A(o, {
          manualExpandedKey: u,
          expanded: R,
          expandSubRows: d
        }) : o;
      }, [a, o, u, R, d]),
      E = t.useMemo(function () {
        return function (e) {
          var t = 0;
          return Object.keys(e).forEach(function (e) {
            var n = e.split(".");
            t = Math.max(t, n.length);
          }), t;
        }(R);
      }, [R]),
      I = h(e),
      F = f(m().getToggleAllRowsExpandedProps, {
        instance: I()
      });
    Object.assign(e, {
      preExpandedRows: o,
      expandedRows: B,
      rows: B,
      expandedDepth: E,
      isAllRowsExpanded: C,
      toggleRowExpanded: x,
      toggleAllRowsExpanded: P,
      getToggleAllRowsExpandedProps: F
    });
  }
  function pe(e, t) {
    var n = t.instance.getHooks,
      o = t.instance;
    e.toggleRowExpanded = function (t) {
      return o.toggleRowExpanded(e.id, t);
    }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
      instance: o,
      row: e
    });
  }
  var ge = function ge(e, t, n) {
    return e = e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return String(o).toLowerCase().includes(String(n).toLowerCase());
      });
    });
  };
  ge.autoRemove = function (e) {
    return !e;
  };
  var ve = function ve(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
      });
    });
  };
  ve.autoRemove = function (e) {
    return !e;
  };
  var me = function me(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return void 0 === o || String(o) === String(n);
      });
    });
  };
  me.autoRemove = function (e) {
    return !e;
  };
  var he = function he(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        return e.values[t].includes(n);
      });
    });
  };
  he.autoRemove = function (e) {
    return !e || !e.length;
  };
  var ye = function ye(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return o && o.length && n.every(function (e) {
          return o.includes(e);
        });
      });
    });
  };
  ye.autoRemove = function (e) {
    return !e || !e.length;
  };
  var we = function we(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return o && o.length && n.some(function (e) {
          return o.includes(e);
        });
      });
    });
  };
  we.autoRemove = function (e) {
    return !e || !e.length;
  };
  var Re = function Re(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        var o = e.values[t];
        return n.includes(o);
      });
    });
  };
  Re.autoRemove = function (e) {
    return !e || !e.length;
  };
  var be = function be(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        return e.values[t] === n;
      });
    });
  };
  be.autoRemove = function (e) {
    return void 0 === e;
  };
  var Se = function Se(e, t, n) {
    return e.filter(function (e) {
      return t.some(function (t) {
        return e.values[t] == n;
      });
    });
  };
  Se.autoRemove = function (e) {
    return null == e;
  };
  var Ce = function Ce(e, t, n) {
    var o = n || [],
      r = o[0],
      i = o[1];
    if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
      var u = r;
      r = i, i = u;
    }
    return e.filter(function (e) {
      return t.some(function (t) {
        var n = e.values[t];
        return n >= r && n <= i;
      });
    });
  };
  Ce.autoRemove = function (e) {
    return !e || "number" != typeof e[0] && "number" != typeof e[1];
  };
  var xe = Object.freeze({
    __proto__: null,
    text: ge,
    exactText: ve,
    exactTextCase: me,
    includes: he,
    includesAll: ye,
    includesSome: we,
    includesValue: Re,
    exact: be,
    equals: Se,
    between: Ce
  });
  l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
  var Pe = function Pe(e) {
    e.stateReducers.push(Be), e.useInstance.push(Ee);
  };
  function Be(e, t, n, o) {
    if (t.type === l.init) return r({
      filters: []
    }, e);
    if (t.type === l.resetFilters) return r({}, e, {
      filters: o.initialState.filters || []
    });
    if (t.type === l.setFilter) {
      var i = t.columnId,
        u = t.filterValue,
        s = o.allColumns,
        a = o.filterTypes,
        c = s.find(function (e) {
          return e.id === i;
        });
      if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
      var d = k(c.filter, a || {}, xe),
        f = e.filters.find(function (e) {
          return e.id === i;
        }),
        p = m(u, f && f.value);
      return H(d.autoRemove, p, c) ? r({}, e, {
        filters: e.filters.filter(function (e) {
          return e.id !== i;
        })
      }) : r({}, e, f ? {
        filters: e.filters.map(function (e) {
          return e.id === i ? {
            id: i,
            value: p
          } : e;
        })
      } : {
        filters: [].concat(e.filters, [{
          id: i,
          value: p
        }])
      });
    }
    if (t.type === l.setAllFilters) {
      var g = t.filters,
        v = o.allColumns,
        h = o.filterTypes;
      return r({}, e, {
        filters: m(g, e.filters).filter(function (e) {
          var t = v.find(function (t) {
            return t.id === e.id;
          });
          return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
        })
      });
    }
  }
  function Ee(e) {
    var n = e.data,
      o = e.rows,
      r = e.flatRows,
      i = e.rowsById,
      u = e.allColumns,
      s = e.filterTypes,
      a = e.manualFilters,
      c = e.defaultCanFilter,
      d = void 0 !== c && c,
      f = e.disableFilters,
      p = e.state.filters,
      g = e.dispatch,
      v = e.autoResetFilters,
      m = void 0 === v || v,
      y = t.useCallback(function (e, t) {
        g({
          type: l.setFilter,
          columnId: e,
          filterValue: t
        });
      }, [g]),
      R = t.useCallback(function (e) {
        g({
          type: l.setAllFilters,
          filters: e
        });
      }, [g]);
    u.forEach(function (e) {
      var t = e.id,
        n = e.accessor,
        o = e.defaultCanFilter,
        r = e.disableFilters;
      e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function (t) {
        return y(e.id, t);
      };
      var i = p.find(function (e) {
        return e.id === t;
      });
      e.filterValue = i && i.value;
    });
    var b = t.useMemo(function () {
        if (a || !p.length) return [o, r, i];
        var e = [],
          t = {};
        return [function n(o, r) {
          void 0 === r && (r = 0);
          var i = o;
          return (i = p.reduce(function (e, t) {
            var n = t.id,
              o = t.value,
              i = u.find(function (e) {
                return e.id === n;
              });
            if (!i) return e;
            0 === r && (i.preFilteredRows = e);
            var l = k(i.filter, s || {}, xe);
            return l ? (i.filteredRows = l(e, [n], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
          }, o)).forEach(function (o) {
            e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
          }), i;
        }(o), e, t];
      }, [a, p, o, r, i, u, s]),
      S = b[0],
      C = b[1],
      x = b[2];
    t.useMemo(function () {
      u.filter(function (e) {
        return !p.find(function (t) {
          return t.id === e.id;
        });
      }).forEach(function (e) {
        e.preFilteredRows = S, e.filteredRows = S;
      });
    }, [S, p, u]);
    var P = h(m);
    w(function () {
      P() && g({
        type: l.resetFilters
      });
    }, [g, a ? null : n]), Object.assign(e, {
      preFilteredRows: o,
      preFilteredFlatRows: r,
      preFilteredRowsById: i,
      filteredRows: S,
      filteredFlatRows: C,
      filteredRowsById: x,
      rows: S,
      flatRows: C,
      rowsById: x,
      setFilter: y,
      setAllFilters: R
    });
  }
  Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
  var Ie = function Ie(e) {
    e.stateReducers.push(Fe), e.useInstance.push(Ge);
  };
  function Fe(e, t, n, o) {
    if (t.type === l.resetGlobalFilter) return r({}, e, {
      globalFilter: o.initialState.globalFilter || void 0
    });
    if (t.type === l.setGlobalFilter) {
      var u = t.filterValue,
        s = o.userFilterTypes,
        a = k(o.globalFilter, s || {}, xe),
        c = m(u, e.globalFilter);
      if (H(a.autoRemove, c)) {
        e.globalFilter;
        return i(e, ["globalFilter"]);
      }
      return r({}, e, {
        globalFilter: c
      });
    }
  }
  function Ge(e) {
    var n = e.data,
      o = e.rows,
      r = e.flatRows,
      i = e.rowsById,
      u = e.allColumns,
      s = e.filterTypes,
      a = e.globalFilter,
      c = e.manualGlobalFilter,
      d = e.state.globalFilter,
      f = e.dispatch,
      p = e.autoResetGlobalFilter,
      g = void 0 === p || p,
      v = e.disableGlobalFilter,
      m = t.useCallback(function (e) {
        f({
          type: l.setGlobalFilter,
          filterValue: e
        });
      }, [f]),
      y = t.useMemo(function () {
        if (c || void 0 === d) return [o, r, i];
        var e = [],
          t = {},
          n = k(a, s || {}, xe);
        if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
        u.forEach(function (e) {
          var t = e.disableGlobalFilter;
          e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
        });
        var l = u.filter(function (e) {
          return !0 === e.canFilter;
        });
        return [function o(r) {
          return (r = n(r, l.map(function (e) {
            return e.id;
          }), d)).forEach(function (n) {
            e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
          }), r;
        }(o), e, t];
      }, [c, d, a, s, u, o, r, i, v]),
      R = y[0],
      b = y[1],
      S = y[2],
      C = h(g);
    w(function () {
      C() && f({
        type: l.resetGlobalFilter
      });
    }, [f, c ? null : n]), Object.assign(e, {
      preGlobalFilteredRows: o,
      preGlobalFilteredFlatRows: r,
      preGlobalFilteredRowsById: i,
      globalFilteredRows: R,
      globalFilteredFlatRows: b,
      globalFilteredRowsById: S,
      rows: R,
      flatRows: b,
      rowsById: S,
      setGlobalFilter: m,
      disableGlobalFilter: v
    });
  }
  function Ae(e, t) {
    return t.reduce(function (e, t) {
      return e + ("number" == typeof t ? t : 0);
    }, 0);
  }
  Ie.pluginName = "useGlobalFilter";
  var ke = Object.freeze({
      __proto__: null,
      sum: Ae,
      min: function min(e) {
        var t = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.min(t, e));
        }), t;
      },
      max: function max(e) {
        var t = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.max(t, e));
        }), t;
      },
      minMax: function minMax(e) {
        var t = e[0] || 0,
          n = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
        }), t + ".." + n;
      },
      average: function average(e) {
        return Ae(0, e) / e.length;
      },
      median: function median(e) {
        if (!e.length) return null;
        var t = Math.floor(e.length / 2),
          n = [].concat(e).sort(function (e, t) {
            return e - t;
          });
        return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
      },
      unique: function unique(e) {
        return Array.from(new Set(e).values());
      },
      uniqueCount: function uniqueCount(e) {
        return new Set(e).size;
      },
      count: function count(e) {
        return e.length;
      }
    }),
    He = [],
    We = {};
  l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
  var ze = function ze(e) {
    e.getGroupByToggleProps = [Te], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function (e, t) {
      var n = t.instance;
      return [].concat(e, [n.state.groupBy]);
    }), e.visibleColumns.push(Me), e.useInstance.push(Le), e.prepareRow.push(Ne);
  };
  ze.pluginName = "useGroupBy";
  var Te = function Te(e, t) {
    var n = t.header;
    return [e, {
      onClick: n.canGroupBy ? function (e) {
        e.persist(), n.toggleGroupBy();
      } : void 0,
      style: {
        cursor: n.canGroupBy ? "pointer" : void 0
      },
      title: "Toggle GroupBy"
    }];
  };
  function Oe(e, t, n, o) {
    if (t.type === l.init) return r({
      groupBy: []
    }, e);
    if (t.type === l.resetGroupBy) return r({}, e, {
      groupBy: o.initialState.groupBy || []
    });
    if (t.type === l.setGroupBy) return r({}, e, {
      groupBy: t.value
    });
    if (t.type === l.toggleGroupBy) {
      var i = t.columnId,
        u = t.value,
        s = void 0 !== u ? u : !e.groupBy.includes(i);
      return r({}, e, s ? {
        groupBy: [].concat(e.groupBy, [i])
      } : {
        groupBy: e.groupBy.filter(function (e) {
          return e !== i;
        })
      });
    }
  }
  function Me(e, t) {
    var n = t.instance.state.groupBy,
      o = n.map(function (t) {
        return e.find(function (e) {
          return e.id === t;
        });
      }).filter(Boolean),
      r = e.filter(function (e) {
        return !n.includes(e.id);
      });
    return (e = [].concat(o, r)).forEach(function (e) {
      e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
    }), e;
  }
  var je = {};
  function Le(e) {
    var n = e.data,
      o = e.rows,
      i = e.flatRows,
      u = e.rowsById,
      s = e.allColumns,
      a = e.flatHeaders,
      c = e.groupByFn,
      d = void 0 === c ? De : c,
      p = e.manualGroupBy,
      g = e.aggregations,
      m = void 0 === g ? je : g,
      y = e.plugins,
      R = e.state.groupBy,
      b = e.dispatch,
      S = e.autoResetGroupBy,
      C = void 0 === S || S,
      x = e.disableGroupBy,
      P = e.defaultCanGroupBy,
      B = e.getHooks;
    v(y, ["useColumnOrder", "useFilters"], "useGroupBy");
    var E = h(e);
    s.forEach(function (t) {
      var n = t.accessor,
        o = t.defaultGroupBy,
        r = t.disableGroupBy;
      t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== x && void 0, !0) : I(t.canGroupBy, o, P, !1), t.canGroupBy && (t.toggleGroupBy = function () {
        return e.toggleGroupBy(t.id);
      }), t.Aggregated = t.Aggregated || t.Cell;
    });
    var F = t.useCallback(function (e, t) {
        b({
          type: l.toggleGroupBy,
          columnId: e,
          value: t
        });
      }, [b]),
      A = t.useCallback(function (e) {
        b({
          type: l.setGroupBy,
          value: e
        });
      }, [b]);
    a.forEach(function (e) {
      e.getGroupByToggleProps = f(B().getGroupByToggleProps, {
        instance: E(),
        header: e
      });
    });
    var k = t.useMemo(function () {
        if (p || !R.length) return [o, i, u, He, We, i, u];
        var e = R.filter(function (e) {
            return s.find(function (t) {
              return t.id === e;
            });
          }),
          t = [],
          n = {},
          l = [],
          a = {},
          c = [],
          f = {},
          g = function o(i, u, p) {
            if (void 0 === u && (u = 0), u === e.length) return i.map(function (e) {
              return r({}, e, {
                depth: u
              });
            });
            var g = e[u],
              v = d(i, g);
            return Object.entries(v).map(function (r, i) {
              var d = r[0],
                v = r[1],
                h = g + ":" + d,
                y = o(v, u + 1, h = p ? p + ">" + h : h),
                w = u ? G(v, "leafRows") : v,
                R = function (t, n, o) {
                  var r = {};
                  return s.forEach(function (i) {
                    if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;else {
                      var u = "function" == typeof i.aggregate ? i.aggregate : m[i.aggregate] || ke[i.aggregate];
                      if (u) {
                        var l = n.map(function (e) {
                            return e.values[i.id];
                          }),
                          s = t.map(function (e) {
                            var t = e.values[i.id];
                            if (!o && i.aggregateValue) {
                              var n = "function" == typeof i.aggregateValue ? i.aggregateValue : m[i.aggregateValue] || ke[i.aggregateValue];
                              if (!n) throw console.info({
                                column: i
                              }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                              t = n(t, e, i);
                            }
                            return t;
                          });
                        r[i.id] = u(s, l);
                      } else {
                        if (i.aggregate) throw console.info({
                          column: i
                        }), new Error("React Table: Invalid column.aggregate option for column listed above");
                        r[i.id] = null;
                      }
                    }
                  }), r;
                }(w, v, u),
                b = {
                  id: h,
                  isGrouped: !0,
                  groupByID: g,
                  groupByVal: d,
                  values: R,
                  subRows: y,
                  leafRows: w,
                  depth: u,
                  index: i
                };
              return y.forEach(function (e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
              }), b;
            });
          }(o);
        return g.forEach(function (e) {
          t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
        }), [g, t, n, l, a, c, f];
      }, [p, R, o, i, u, s, m, d]),
      H = k[0],
      W = k[1],
      z = k[2],
      T = k[3],
      O = k[4],
      M = k[5],
      j = k[6],
      L = h(C);
    w(function () {
      L() && b({
        type: l.resetGroupBy
      });
    }, [b, p ? null : n]), Object.assign(e, {
      preGroupedRows: o,
      preGroupedFlatRow: i,
      preGroupedRowsById: u,
      groupedRows: H,
      groupedFlatRows: W,
      groupedRowsById: z,
      onlyGroupedFlatRows: T,
      onlyGroupedRowsById: O,
      nonGroupedFlatRows: M,
      nonGroupedRowsById: j,
      rows: H,
      flatRows: W,
      rowsById: z,
      toggleGroupBy: F,
      setGroupBy: A
    });
  }
  function Ne(e) {
    e.allCells.forEach(function (t) {
      var n;
      t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
    });
  }
  function De(e, t) {
    return e.reduce(function (e, n, o) {
      var r = "" + n.values[t];
      return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
    }, {});
  }
  var Ve = /([0-9]+)/gm;
  function _e(e, t) {
    return e === t ? 0 : e > t ? 1 : -1;
  }
  function Xe(e, t, n) {
    return [e.values[n], t.values[n]];
  }
  function qe(e) {
    return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
  }
  var Ke = Object.freeze({
    __proto__: null,
    alphanumeric: function alphanumeric(e, t, n) {
      var o = Xe(e, t, n),
        r = o[0],
        i = o[1];
      for (r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;) {
        var u = r.shift(),
          l = i.shift(),
          s = parseInt(u, 10),
          a = parseInt(l, 10),
          c = [s, a].sort();
        if (isNaN(c[0])) {
          if (u > l) return 1;
          if (l > u) return -1;
        } else {
          if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
          if (s > a) return 1;
          if (a > s) return -1;
        }
      }
      return r.length - i.length;
    },
    datetime: function datetime(e, t, n) {
      var o = Xe(e, t, n),
        r = o[0],
        i = o[1];
      return _e(r = r.getTime(), i = i.getTime());
    },
    basic: function basic(e, t, n) {
      var o = Xe(e, t, n);
      return _e(o[0], o[1]);
    },
    string: function string(e, t, n) {
      var o = Xe(e, t, n),
        r = o[0],
        i = o[1];
      for (r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;) {
        var u = r.shift(),
          l = i.shift(),
          s = u.toLowerCase(),
          a = l.toLowerCase();
        if (s > a) return 1;
        if (a > s) return -1;
        if (u > l) return 1;
        if (l > u) return -1;
      }
      return r.length - i.length;
    },
    number: function number(e, t, n) {
      var o = Xe(e, t, n),
        r = o[0],
        i = o[1],
        u = /[^0-9.]/gi;
      return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
    }
  });
  l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
  var Ue = function Ue(e) {
    e.getSortByToggleProps = [$e], e.stateReducers.push(Je), e.useInstance.push(Ye);
  };
  Ue.pluginName = "useSortBy";
  var $e = function $e(e, t) {
    var n = t.instance,
      o = t.column,
      r = n.isMultiSortEvent,
      i = void 0 === r ? function (e) {
        return e.shiftKey;
      } : r;
    return [e, {
      onClick: o.canSort ? function (e) {
        e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
      } : void 0,
      style: {
        cursor: o.canSort ? "pointer" : void 0
      },
      title: o.canSort ? "Toggle SortBy" : void 0
    }];
  };
  function Je(e, t, n, o) {
    if (t.type === l.init) return r({
      sortBy: []
    }, e);
    if (t.type === l.resetSortBy) return r({}, e, {
      sortBy: o.initialState.sortBy || []
    });
    if (t.type === l.clearSortBy) return r({}, e, {
      sortBy: e.sortBy.filter(function (e) {
        return e.id !== t.columnId;
      })
    });
    if (t.type === l.setSortBy) return r({}, e, {
      sortBy: t.sortBy
    });
    if (t.type === l.toggleSortBy) {
      var i,
        u = t.columnId,
        s = t.desc,
        a = t.multi,
        c = o.allColumns,
        d = o.disableMultiSort,
        f = o.disableSortRemove,
        p = o.disableMultiRemove,
        g = o.maxMultiSortColCount,
        v = void 0 === g ? Number.MAX_SAFE_INTEGER : g,
        m = e.sortBy,
        h = c.find(function (e) {
          return e.id === u;
        }).sortDescFirst,
        y = m.find(function (e) {
          return e.id === u;
        }),
        w = m.findIndex(function (e) {
          return e.id === u;
        }),
        R = null != s,
        b = [];
      return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [{
        id: u,
        desc: R ? s : h
      }] : "add" === i ? (b = [].concat(m, [{
        id: u,
        desc: R ? s : h
      }])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function (e) {
        return e.id === u ? r({}, e, {
          desc: R ? s : !y.desc
        }) : e;
      }) : "remove" === i && (b = m.filter(function (e) {
        return e.id !== u;
      })), r({}, e, {
        sortBy: b
      });
    }
  }
  function Ye(e) {
    var n = e.data,
      o = e.rows,
      r = e.flatRows,
      i = e.allColumns,
      u = e.orderByFn,
      s = void 0 === u ? Qe : u,
      a = e.sortTypes,
      c = e.manualSortBy,
      d = e.defaultCanSort,
      p = e.disableSortBy,
      g = e.flatHeaders,
      m = e.state.sortBy,
      y = e.dispatch,
      R = e.plugins,
      b = e.getHooks,
      S = e.autoResetSortBy,
      C = void 0 === S || S;
    v(R, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
    var x = t.useCallback(function (e) {
        y({
          type: l.setSortBy,
          sortBy: e
        });
      }, [y]),
      P = t.useCallback(function (e, t, n) {
        y({
          type: l.toggleSortBy,
          columnId: e,
          desc: t,
          multi: n
        });
      }, [y]),
      B = h(e);
    g.forEach(function (e) {
      var t = e.accessor,
        n = e.canSort,
        o = e.disableSortBy,
        r = e.id,
        i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
      e.canSort = i, e.canSort && (e.toggleSortBy = function (t, n) {
        return P(e.id, t, n);
      }, e.clearSortBy = function () {
        y({
          type: l.clearSortBy,
          columnId: e.id
        });
      }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
        instance: B(),
        column: e
      });
      var u = m.find(function (e) {
        return e.id === r;
      });
      e.isSorted = !!u, e.sortedIndex = m.findIndex(function (e) {
        return e.id === r;
      }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
    });
    var E = t.useMemo(function () {
        if (c || !m.length) return [o, r];
        var e = [],
          t = m.filter(function (e) {
            return i.find(function (t) {
              return t.id === e.id;
            });
          });
        return [function n(o) {
          var r = s(o, t.map(function (e) {
            var t = i.find(function (t) {
              return t.id === e.id;
            });
            if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
            var n = t.sortType,
              o = F(n) || (a || {})[n] || Ke[n];
            if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
            return function (t, n) {
              return o(t, n, e.id, e.desc);
            };
          }), t.map(function (e) {
            var t = i.find(function (t) {
              return t.id === e.id;
            });
            return t && t.sortInverted ? e.desc : !e.desc;
          }));
          return r.forEach(function (t) {
            e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
          }), r;
        }(o), e];
      }, [c, m, o, r, i, s, a]),
      G = E[0],
      A = E[1],
      k = h(C);
    w(function () {
      k() && y({
        type: l.resetSortBy
      });
    }, [c ? null : n]), Object.assign(e, {
      preSortedRows: o,
      preSortedFlatRows: r,
      sortedRows: G,
      sortedFlatRows: A,
      rows: G,
      flatRows: A,
      setSortBy: x,
      toggleSortBy: P
    });
  }
  function Qe(e, t, n) {
    return [].concat(e).sort(function (e, o) {
      for (var r = 0; r < t.length; r += 1) {
        var i = t[r],
          u = !1 === n[r] || "desc" === n[r],
          l = i(e, o);
        if (0 !== l) return u ? -l : l;
      }
      return n[0] ? e.index - o.index : o.index - e.index;
    });
  }
  l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
  var Ze = function Ze(e) {
    e.stateReducers.push(et), e.useInstance.push(tt);
  };
  function et(e, t, n, o) {
    if (t.type === l.init) return r({
      pageSize: 10,
      pageIndex: 0
    }, e);
    if (t.type === l.resetPage) return r({}, e, {
      pageIndex: o.initialState.pageIndex || 0
    });
    if (t.type === l.gotoPage) {
      var i = o.pageCount,
        u = o.page,
        s = m(t.pageIndex, e.pageIndex),
        a = !1;
      return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
        pageIndex: s
      }) : e;
    }
    if (t.type === l.setPageSize) {
      var c = t.pageSize,
        d = e.pageSize * e.pageIndex;
      return r({}, e, {
        pageIndex: Math.floor(d / c),
        pageSize: c
      });
    }
  }
  function tt(e) {
    var n = e.rows,
      o = e.autoResetPage,
      r = void 0 === o || o,
      i = e.manualExpandedKey,
      u = void 0 === i ? "expanded" : i,
      s = e.plugins,
      a = e.pageCount,
      c = e.paginateExpandedRows,
      d = void 0 === c || c,
      f = e.expandSubRows,
      p = void 0 === f || f,
      g = e.state,
      m = g.pageSize,
      y = g.pageIndex,
      R = g.expanded,
      b = g.globalFilter,
      S = g.filters,
      C = g.groupBy,
      x = g.sortBy,
      P = e.dispatch,
      B = e.data,
      E = e.manualPagination;
    v(s, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
    var I = h(r);
    w(function () {
      I() && P({
        type: l.resetPage
      });
    }, [P, E ? null : B, b, S, C, x]);
    var F = E ? a : Math.ceil(n.length / m),
      G = t.useMemo(function () {
        return F > 0 ? [].concat(new Array(F)).fill(null).map(function (e, t) {
          return t;
        }) : [];
      }, [F]),
      k = t.useMemo(function () {
        var e;
        if (E) e = n;else {
          var t = m * y,
            o = t + m;
          e = n.slice(t, o);
        }
        return d ? e : A(e, {
          manualExpandedKey: u,
          expanded: R,
          expandSubRows: p
        });
      }, [p, R, u, E, y, m, d, n]),
      H = y > 0,
      W = -1 === F ? k.length >= m : y < F - 1,
      z = t.useCallback(function (e) {
        P({
          type: l.gotoPage,
          pageIndex: e
        });
      }, [P]),
      T = t.useCallback(function () {
        return z(function (e) {
          return e - 1;
        });
      }, [z]),
      O = t.useCallback(function () {
        return z(function (e) {
          return e + 1;
        });
      }, [z]),
      M = t.useCallback(function (e) {
        P({
          type: l.setPageSize,
          pageSize: e
        });
      }, [P]);
    Object.assign(e, {
      pageOptions: G,
      pageCount: F,
      page: k,
      canPreviousPage: H,
      canNextPage: W,
      gotoPage: z,
      previousPage: T,
      nextPage: O,
      setPageSize: M
    });
  }
  Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
  var nt = function nt(e) {
    e.getPivotToggleProps = [rt], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
  };
  nt.pluginName = "usePivotColumns";
  var ot = [],
    rt = function rt(e, t) {
      var n = t.header;
      return [e, {
        onClick: n.canPivot ? function (e) {
          e.persist(), n.togglePivot();
        } : void 0,
        style: {
          cursor: n.canPivot ? "pointer" : void 0
        },
        title: "Toggle Pivot"
      }];
    };
  function it(e, t, n, o) {
    if (t.type === l.init) return r({
      pivotColumns: ot
    }, e);
    if (t.type === l.resetPivot) return r({}, e, {
      pivotColumns: o.initialState.pivotColumns || ot
    });
    if (t.type === l.togglePivot) {
      var i = t.columnId,
        u = t.value,
        s = void 0 !== u ? u : !e.pivotColumns.includes(i);
      return r({}, e, s ? {
        pivotColumns: [].concat(e.pivotColumns, [i])
      } : {
        pivotColumns: e.pivotColumns.filter(function (e) {
          return e !== i;
        })
      });
    }
  }
  function ut(e) {
    e.allColumns.forEach(function (t) {
      t.isPivotSource = e.state.pivotColumns.includes(t.id);
    });
  }
  function lt(e, t) {
    var n = t.instance;
    return e.forEach(function (e) {
      e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set();
    }), e;
  }
  function st(e, t) {
    var n = t.column;
    return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
  }
  function at(e, t) {
    var n = t.instance,
      o = n.allColumns,
      i = n.state;
    if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
    var u = i.pivotColumns.map(function (e) {
        return o.find(function (t) {
          return t.id === e;
        });
      }).filter(Boolean),
      l = o.filter(function (e) {
        return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
      }),
      s = C(function e(t, n, o) {
        void 0 === t && (t = 0), void 0 === o && (o = []);
        var i = u[t];
        return i ? Array.from(i.uniqueValues).sort().map(function (u) {
          var l = r({}, i, {
            Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
            isPivotGroup: !0,
            parent: n,
            depth: t,
            id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
            pivotValue: u
          });
          return l.columns = e(t + 1, l, [].concat(o, [function (e) {
            return e.values[i.id] === u;
          }])), l;
        }) : l.map(function (e) {
          return r({}, e, {
            canPivot: !1,
            isPivoted: !0,
            parent: n,
            depth: t,
            id: "" + (n ? n.id + "." + e.id : e.id),
            accessor: function accessor(t, n, r) {
              if (o.every(function (e) {
                return e(r);
              })) return r.values[e.id];
            }
          });
        });
      }());
    return [].concat(e, s);
  }
  function ct(e, t) {
    var n = t.instance.state,
      o = n.pivotColumns,
      r = n.groupBy;
    return [].concat(e, [o, r]);
  }
  function dt(e, t) {
    var n = t.instance.state;
    return e = e.filter(function (e) {
      return !e.isPivotSource;
    }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function (e) {
      return e.isGrouped || e.isPivoted;
    })), e;
  }
  function ft(e, t) {
    var n = t.instance;
    return [].concat(e, [n.state.pivotColumns, n.state.groupBy]);
  }
  function pt(e) {
    var t = e.columns,
      n = e.allColumns,
      o = e.flatHeaders,
      r = e.getHooks,
      i = e.plugins,
      u = e.dispatch,
      s = e.autoResetPivot,
      a = void 0 === s || s,
      c = e.manaulPivot,
      d = e.disablePivot,
      p = e.defaultCanPivot;
    v(i, ["useGroupBy"], "usePivotColumns");
    var g = h(e);
    n.forEach(function (t) {
      var n = t.accessor,
        o = t.defaultPivot,
        r = t.disablePivot;
      t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function () {
        return e.togglePivot(t.id);
      }), t.Aggregated = t.Aggregated || t.Cell;
    });
    o.forEach(function (e) {
      e.getPivotToggleProps = f(r().getPivotToggleProps, {
        instance: g(),
        header: e
      });
    });
    var m = h(a);
    w(function () {
      m() && u({
        type: l.resetPivot
      });
    }, [u, c ? null : t]), Object.assign(e, {
      togglePivot: function togglePivot(e, t) {
        u({
          type: l.togglePivot,
          columnId: e,
          value: t
        });
      }
    });
  }
  function gt(e) {
    e.allCells.forEach(function (e) {
      e.isPivoted = e.column.isPivoted;
    });
  }
  l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
  var vt = function vt(e) {
    e.getToggleRowSelectedProps = [mt], e.getToggleAllRowsSelectedProps = [ht], e.getToggleAllPageRowsSelectedProps = [yt], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
  };
  vt.pluginName = "useRowSelect";
  var mt = function mt(e, t) {
      var n = t.instance,
        o = t.row,
        r = n.manualRowSelectedKey,
        i = void 0 === r ? "isSelected" : r;
      return [e, {
        onChange: function onChange(e) {
          o.toggleRowSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: !(!o.original || !o.original[i]) || o.isSelected,
        title: "Toggle Row Selected",
        indeterminate: o.isSomeSelected
      }];
    },
    ht = function ht(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function onChange(e) {
          n.toggleAllRowsSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isAllRowsSelected,
        title: "Toggle All Rows Selected",
        indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
      }];
    },
    yt = function yt(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function onChange(e) {
          n.toggleAllPageRowsSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isAllPageRowsSelected,
        title: "Toggle All Current Page Rows Selected",
        indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function (e) {
          var t = e.id;
          return n.state.selectedRowIds[t];
        }))
      }];
    };
  function wt(e, t, n, o) {
    if (t.type === l.init) return r({
      selectedRowIds: {}
    }, e);
    if (t.type === l.resetSelectedRows) return r({}, e, {
      selectedRowIds: o.initialState.selectedRowIds || {}
    });
    if (t.type === l.toggleAllRowsSelected) {
      var i = t.value,
        u = o.isAllRowsSelected,
        s = o.rowsById,
        a = o.nonGroupedRowsById,
        c = void 0 === a ? s : a,
        d = void 0 !== i ? i : !u,
        f = Object.assign({}, e.selectedRowIds);
      return d ? Object.keys(c).forEach(function (e) {
        f[e] = !0;
      }) : Object.keys(c).forEach(function (e) {
        delete f[e];
      }), r({}, e, {
        selectedRowIds: f
      });
    }
    if (t.type === l.toggleRowSelected) {
      var p = t.id,
        g = t.value,
        v = o.rowsById,
        m = o.selectSubRows,
        h = void 0 === m || m,
        y = o.getSubRows,
        w = e.selectedRowIds[p],
        R = void 0 !== g ? g : !w;
      if (w === R) return e;
      var b = r({}, e.selectedRowIds);
      return function e(t) {
        var n = v[t];
        if (n && (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n))) return y(n).forEach(function (t) {
          return e(t.id);
        });
      }(p), r({}, e, {
        selectedRowIds: b
      });
    }
    if (t.type === l.toggleAllPageRowsSelected) {
      var S = t.value,
        C = o.page,
        x = o.rowsById,
        P = o.selectSubRows,
        B = void 0 === P || P,
        E = o.isAllPageRowsSelected,
        I = o.getSubRows,
        F = void 0 !== S ? S : !E,
        G = r({}, e.selectedRowIds);
      return C.forEach(function (e) {
        return function e(t) {
          var n = x[t];
          if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function (t) {
            return e(t.id);
          });
        }(e.id);
      }), r({}, e, {
        selectedRowIds: G
      });
    }
    return e;
  }
  function Rt(e) {
    var n = e.data,
      o = e.rows,
      r = e.getHooks,
      i = e.plugins,
      u = e.rowsById,
      s = e.nonGroupedRowsById,
      a = void 0 === s ? u : s,
      c = e.autoResetSelectedRows,
      d = void 0 === c || c,
      p = e.state.selectedRowIds,
      g = e.selectSubRows,
      m = void 0 === g || g,
      y = e.dispatch,
      R = e.page,
      b = e.getSubRows;
    v(i, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
    var S = t.useMemo(function () {
        var e = [];
        return o.forEach(function (t) {
          var n = m ? function e(t, n, o) {
            if (n[t.id]) return !0;
            var r = o(t);
            if (r && r.length) {
              var i = !0,
                u = !1;
              return r.forEach(function (t) {
                u && !i || (e(t, n, o) ? u = !0 : i = !1);
              }), !!i || !!u && null;
            }
            return !1;
          }(t, p, b) : !!p[t.id];
          t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
        }), e;
      }, [o, m, p, b]),
      C = Boolean(Object.keys(a).length && Object.keys(p).length),
      x = C;
    C && Object.keys(a).some(function (e) {
      return !p[e];
    }) && (C = !1), C || R && R.length && R.some(function (e) {
      var t = e.id;
      return !p[t];
    }) && (x = !1);
    var P = h(d);
    w(function () {
      P() && y({
        type: l.resetSelectedRows
      });
    }, [y, n]);
    var B = t.useCallback(function (e) {
        return y({
          type: l.toggleAllRowsSelected,
          value: e
        });
      }, [y]),
      E = t.useCallback(function (e) {
        return y({
          type: l.toggleAllPageRowsSelected,
          value: e
        });
      }, [y]),
      I = t.useCallback(function (e, t) {
        return y({
          type: l.toggleRowSelected,
          id: e,
          value: t
        });
      }, [y]),
      F = h(e),
      G = f(r().getToggleAllRowsSelectedProps, {
        instance: F()
      }),
      A = f(r().getToggleAllPageRowsSelectedProps, {
        instance: F()
      });
    Object.assign(e, {
      selectedFlatRows: S,
      isAllRowsSelected: C,
      isAllPageRowsSelected: x,
      toggleRowSelected: I,
      toggleAllRowsSelected: B,
      getToggleAllRowsSelectedProps: G,
      getToggleAllPageRowsSelectedProps: A,
      toggleAllPageRowsSelected: E
    });
  }
  function bt(e, t) {
    var n = t.instance;
    e.toggleRowSelected = function (t) {
      return n.toggleRowSelected(e.id, t);
    }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
      instance: n,
      row: e
    });
  }
  var St = function St(e) {
      return {};
    },
    Ct = function Ct(e) {
      return {};
    };
  l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
  var xt = function xt(e) {
    e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
  };
  function Pt(e, t, n, o) {
    var i = o.initialRowStateAccessor,
      u = void 0 === i ? St : i,
      s = o.initialCellStateAccessor,
      a = void 0 === s ? Ct : s,
      c = o.rowsById;
    if (t.type === l.init) return r({
      rowState: {}
    }, e);
    if (t.type === l.resetRowState) return r({}, e, {
      rowState: o.initialState.rowState || {}
    });
    if (t.type === l.setRowState) {
      var d,
        f = t.rowId,
        p = t.value,
        g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
      return r({}, e, {
        rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
      });
    }
    if (t.type === l.setCellState) {
      var v,
        h,
        y,
        w,
        R,
        b = t.rowId,
        S = t.columnId,
        C = t.value,
        x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]),
        P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function (e) {
          return e.column.id === S;
        }));
      return r({}, e, {
        rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
          cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
        }), R))
      });
    }
  }
  function Bt(e) {
    var n = e.autoResetRowState,
      o = void 0 === n || n,
      r = e.data,
      i = e.dispatch,
      u = t.useCallback(function (e, t) {
        return i({
          type: l.setRowState,
          rowId: e,
          value: t
        });
      }, [i]),
      s = t.useCallback(function (e, t, n) {
        return i({
          type: l.setCellState,
          rowId: e,
          columnId: t,
          value: n
        });
      }, [i]),
      a = h(o);
    w(function () {
      a() && i({
        type: l.resetRowState
      });
    }, [r]), Object.assign(e, {
      setRowState: u,
      setCellState: s
    });
  }
  function Et(e, t) {
    var n = t.instance,
      o = n.initialRowStateAccessor,
      r = void 0 === o ? St : o,
      i = n.initialCellStateAccessor,
      u = void 0 === i ? Ct : i,
      l = n.state.rowState;
    e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function (t) {
      return n.setRowState(e.id, t);
    }, e.cells.forEach(function (t) {
      e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function (o) {
        return n.setCellState(e.id, t.column.id, o);
      };
    }));
  }
  xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
  var It = function It(e) {
    e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function (e, t) {
      var n = t.instance;
      return [].concat(e, [n.state.columnOrder]);
    }), e.visibleColumns.push(Gt), e.useInstance.push(At);
  };
  function Ft(e, t, n, o) {
    return t.type === l.init ? r({
      columnOrder: []
    }, e) : t.type === l.resetColumnOrder ? r({}, e, {
      columnOrder: o.initialState.columnOrder || []
    }) : t.type === l.setColumnOrder ? r({}, e, {
      columnOrder: m(t.columnOrder, e.columnOrder)
    }) : void 0;
  }
  function Gt(e, t) {
    var n = t.instance.state.columnOrder;
    if (!n || !n.length) return e;
    for (var o = [].concat(n), r = [].concat(e), i = [], u = function u() {
        var e = o.shift(),
          t = r.findIndex(function (t) {
            return t.id === e;
          });
        t > -1 && i.push(r.splice(t, 1)[0]);
      }; r.length && o.length;) {
      u();
    }
    return [].concat(i, r);
  }
  function At(e) {
    var n = e.dispatch;
    e.setColumnOrder = t.useCallback(function (e) {
      return n({
        type: l.setColumnOrder,
        columnOrder: e
      });
    }, [n]);
  }
  It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
  var kt = function kt(e) {
      e.getResizerProps = [Ht], e.getHeaderProps.push({
        style: {
          position: "relative"
        }
      }), e.stateReducers.push(Wt), e.useInstance.push(Tt), e.useInstanceBeforeDimensions.push(zt);
    },
    Ht = function Ht(e, t) {
      var n = t.instance,
        o = t.header,
        r = n.dispatch,
        i = function i(e, t) {
          var n = !1;
          if ("touchstart" === e.type) {
            if (e.touches && e.touches.length > 1) return;
            n = !0;
          }
          var o,
            i,
            u = function (e) {
              var t = [];
              return function e(n) {
                n.columns && n.columns.length && n.columns.map(e);
                t.push(n);
              }(e), t;
            }(t).map(function (e) {
              return [e.id, e.totalWidth];
            }),
            s = n ? Math.round(e.touches[0].clientX) : e.clientX,
            a = function a() {
              window.cancelAnimationFrame(o), o = null, r({
                type: l.columnDoneResizing
              });
            },
            c = function c() {
              window.cancelAnimationFrame(o), o = null, r({
                type: l.columnResizing,
                clientX: i
              });
            },
            d = function d(e) {
              i = e, o || (o = window.requestAnimationFrame(c));
            },
            f = {
              mouse: {
                moveEvent: "mousemove",
                moveHandler: function moveHandler(e) {
                  return d(e.clientX);
                },
                upEvent: "mouseup",
                upHandler: function upHandler(e) {
                  document.removeEventListener("mousemove", f.mouse.moveHandler), document.removeEventListener("mouseup", f.mouse.upHandler), a();
                }
              },
              touch: {
                moveEvent: "touchmove",
                moveHandler: function moveHandler(e) {
                  return e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0].clientX), !1;
                },
                upEvent: "touchend",
                upHandler: function upHandler(e) {
                  document.removeEventListener(f.touch.moveEvent, f.touch.moveHandler), document.removeEventListener(f.touch.upEvent, f.touch.moveHandler), a();
                }
              }
            },
            p = n ? f.touch : f.mouse,
            g = !!function () {
              if ("boolean" == typeof z) return z;
              var e = !1;
              try {
                var t = {
                  get passive() {
                    return e = !0, !1;
                  }
                };
                window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
              } catch (t) {
                e = !1;
              }
              return z = e;
            }() && {
              passive: !1
            };
          document.addEventListener(p.moveEvent, p.moveHandler, g), document.addEventListener(p.upEvent, p.upHandler, g), r({
            type: l.columnStartResizing,
            columnId: t.id,
            columnWidth: t.totalWidth,
            headerIdWidths: u,
            clientX: s
          });
        };
      return [e, {
        onMouseDown: function onMouseDown(e) {
          return e.persist() || i(e, o);
        },
        onTouchStart: function onTouchStart(e) {
          return e.persist() || i(e, o);
        },
        style: {
          cursor: "col-resize"
        },
        draggable: !1,
        role: "separator"
      }];
    };
  function Wt(e, t) {
    if (t.type === l.init) return r({
      columnResizing: {
        columnWidths: {}
      }
    }, e);
    if (t.type === l.resetResize) return r({}, e, {
      columnResizing: {
        columnWidths: {}
      }
    });
    if (t.type === l.columnStartResizing) {
      var n = t.clientX,
        o = t.columnId,
        i = t.columnWidth,
        u = t.headerIdWidths;
      return r({}, e, {
        columnResizing: r({}, e.columnResizing, {
          startX: n,
          headerIdWidths: u,
          columnWidth: i,
          isResizingColumn: o
        })
      });
    }
    if (t.type === l.columnResizing) {
      var s = t.clientX,
        a = e.columnResizing,
        c = a.startX,
        d = a.columnWidth,
        f = a.headerIdWidths,
        p = (s - c) / d,
        g = {};
      return (void 0 === f ? [] : f).forEach(function (e) {
        var t = e[0],
          n = e[1];
        g[t] = Math.max(n + n * p, 0);
      }), r({}, e, {
        columnResizing: r({}, e.columnResizing, {
          columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
        })
      });
    }
    return t.type === l.columnDoneResizing ? r({}, e, {
      columnResizing: r({}, e.columnResizing, {
        startX: null,
        isResizingColumn: null
      })
    }) : void 0;
  }
  kt.pluginName = "useResizeColumns";
  var zt = function zt(e) {
    var t = e.flatHeaders,
      n = e.disableResizing,
      o = e.getHooks,
      r = e.state.columnResizing,
      i = h(e);
    t.forEach(function (e) {
      var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
      e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
        instance: i(),
        header: e
      }));
    });
  };
  function Tt(e) {
    var n = e.plugins,
      o = e.dispatch,
      r = e.autoResetResize,
      i = void 0 === r || r,
      u = e.columns;
    v(n, ["useAbsoluteLayout"], "useResizeColumns");
    var s = h(i);
    w(function () {
      s() && o({
        type: l.resetResize
      });
    }, [u]);
    var a = t.useCallback(function () {
      return o({
        type: l.resetResize
      });
    }, [o]);
    Object.assign(e, {
      resetResizing: a
    });
  }
  var Ot = {
      position: "absolute",
      top: 0
    },
    Mt = function Mt(e) {
      e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Ot, {
            left: n.totalLeft + "px",
            width: n.totalWidth + "px"
          })
        }];
      }), e.getCellProps.push(function (e, t) {
        var n = t.cell;
        return [e, {
          style: r({}, Ot, {
            left: n.column.totalLeft + "px",
            width: n.column.totalWidth + "px"
          })
        }];
      }), e.getFooterProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Ot, {
            left: n.totalLeft + "px",
            width: n.totalWidth + "px"
          })
        }];
      });
    };
  Mt.pluginName = "useAbsoluteLayout";
  var jt = function jt(e, t) {
      return [e, {
        style: {
          position: "relative",
          width: t.instance.totalColumnsWidth + "px"
        }
      }];
    },
    Lt = {
      display: "inline-block",
      boxSizing: "border-box"
    },
    Nt = function Nt(e, t) {
      return [e, {
        style: {
          display: "flex",
          width: t.instance.totalColumnsWidth + "px"
        }
      }];
    },
    Dt = function Dt(e) {
      e.getRowProps.push(Nt), e.getHeaderGroupProps.push(Nt), e.getFooterGroupProps.push(Nt), e.getHeaderProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Lt, {
            width: n.totalWidth + "px"
          })
        }];
      }), e.getCellProps.push(function (e, t) {
        var n = t.cell;
        return [e, {
          style: r({}, Lt, {
            width: n.column.totalWidth + "px"
          })
        }];
      }), e.getFooterProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Lt, {
            width: n.totalWidth + "px"
          })
        }];
      });
    };
  function Vt(e) {
    e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
  }
  Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
  var _t = function _t(e, t) {
      return [e, {
        style: {
          minWidth: t.instance.totalColumnsMinWidth + "px"
        }
      }];
    },
    Xt = function Xt(e, t) {
      return [e, {
        style: {
          display: "flex",
          flex: "1 0 auto",
          minWidth: t.instance.totalColumnsMinWidth + "px"
        }
      }];
    },
    qt = function qt(e, t) {
      var n = t.column;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
          minWidth: n.totalMinWidth + "px",
          width: n.totalWidth + "px"
        }
      }];
    },
    Kt = function Kt(e, t) {
      var n = t.cell;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.column.totalFlexWidth + " 0 auto",
          minWidth: n.column.totalMinWidth + "px",
          width: n.column.totalWidth + "px"
        }
      }];
    },
    Ut = function Ut(e, t) {
      var n = t.column;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
          minWidth: n.totalMinWidth + "px",
          width: n.totalWidth + "px"
        }
      }];
    };
  function $t(e) {
    e.stateReducers.push(Zt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt), e.getRowProps.push(Qt);
  }
  l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize", $t.pluginName = "useGridLayout";
  var Jt = function Jt(e, t) {
      var n = t.instance;
      return [e, {
        style: {
          display: "grid",
          gridTemplateColumns: n.visibleColumns.map(function (e) {
            var t;
            return n.state.gridLayout.columnWidths[e.id] ? n.state.gridLayout.columnWidths[e.id] + "px" : (null == (t = n.state.columnResizing) ? void 0 : t.isResizingColumn) ? n.state.gridLayout.startWidths[e.id] + "px" : "number" == typeof e.width ? e.width + "px" : e.width;
          }).join(" ")
        }
      }];
    },
    Yt = function Yt(e, t) {
      var n = t.column;
      return [e, {
        id: "header-cell-" + n.id,
        style: {
          position: "sticky",
          gridColumn: "span " + n.totalVisibleHeaderCount
        }
      }];
    },
    Qt = function Qt(e, t) {
      var n = t.row;
      return n.isExpanded ? [e, {
        style: {
          gridColumn: "1 / " + (n.cells.length + 1)
        }
      }] : [e, {}];
    };
  function Zt(e, t, n, o) {
    if (t.type === l.init) return r({
      gridLayout: {
        columnWidths: {}
      }
    }, e);
    if (t.type === l.resetResize) return r({}, e, {
      gridLayout: {
        columnWidths: {}
      }
    });
    if (t.type === l.columnStartResizing) {
      var i = t.columnId,
        u = t.headerIdWidths,
        s = en(i);
      if (void 0 !== s) {
        var a = o.visibleColumns.reduce(function (e, t) {
            var n;
            return r({}, e, ((n = {})[t.id] = en(t.id), n));
          }, {}),
          c = o.visibleColumns.reduce(function (e, t) {
            var n;
            return r({}, e, ((n = {})[t.id] = t.minWidth, n));
          }, {}),
          d = o.visibleColumns.reduce(function (e, t) {
            var n;
            return r({}, e, ((n = {})[t.id] = t.maxWidth, n));
          }, {}),
          f = u.map(function (e) {
            var t = e[0];
            return [t, en(t)];
          });
        return r({}, e, {
          gridLayout: r({}, e.gridLayout, {
            startWidths: a,
            minWidths: c,
            maxWidths: d,
            headerIdGridWidths: f,
            columnWidth: s
          })
        });
      }
      return e;
    }
    if (t.type === l.columnResizing) {
      var p = t.clientX,
        g = e.columnResizing.startX,
        v = e.gridLayout,
        m = v.columnWidth,
        h = v.minWidths,
        y = v.maxWidths,
        w = v.headerIdGridWidths,
        R = (p - g) / m,
        b = {};
      return (void 0 === w ? [] : w).forEach(function (e) {
        var t = e[0],
          n = e[1];
        b[t] = Math.min(Math.max(h[t], n + n * R), y[t]);
      }), r({}, e, {
        gridLayout: r({}, e.gridLayout, {
          columnWidths: r({}, e.gridLayout.columnWidths, {}, b)
        })
      });
    }
    return t.type === l.columnDoneResizing ? r({}, e, {
      gridLayout: r({}, e.gridLayout, {
        startWidths: {},
        minWidths: {},
        maxWidths: {}
      })
    }) : void 0;
  }
  function en(e) {
    var t,
      n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
    if (void 0 !== n) return n;
  }
  e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function (e, n) {
    void 0 === n && (n = 0);
    var r = t.useRef({}),
      i = h(e),
      u = h(n);
    return t.useCallback(function () {
      var e = o(_regeneratorRuntime().mark(function e() {
        var t,
          n,
          l,
          s = arguments;
        return _regeneratorRuntime().wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                for (t = s.length, n = new Array(t), l = 0; l < t; l++) {
                  n[l] = s[l];
                }
                return r.current.promise || (r.current.promise = new Promise(function (e, t) {
                  r.current.resolve = e, r.current.reject = t;
                })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(_regeneratorRuntime().mark(function e() {
                  return _regeneratorRuntime().wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                        case 5:
                          e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                          break;
                        case 9:
                          e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                        case 12:
                          return e.prev = 12, delete r.current.promise, e.finish(12);
                        case 15:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, null, [[1, 9, 12, 15]]);
                })), u()), e.abrupt("return", r.current.promise);
              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function () {
        return e.apply(this, arguments);
      };
    }(), [i, u]);
  }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function (e) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
      o[i - 1] = arguments[i];
    }
    e = ie(e), o = [K].concat(o);
    var u = t.useRef({}),
      s = h(u.current);
    Object.assign(s(), r({}, e, {
      plugins: o,
      hooks: q()
    })), o.filter(Boolean).forEach(function (e) {
      e(s().hooks);
    });
    var a = h(s().hooks);
    s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
    var c = s(),
      d = c.data,
      v = c.columns,
      m = c.initialState,
      y = c.defaultColumn,
      w = c.getSubRows,
      b = c.getRowId,
      E = c.stateReducer,
      I = c.useControlledState,
      F = h(E),
      G = t.useCallback(function (e, t) {
        if (!t.type) throw console.info({
          action: t
        }), new Error("Unknown Action 👆");
        return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [F()]).reduce(function (n, o) {
          return o(n, t, e, s()) || n;
        }, e);
      }, [a, F, s]),
      A = t.useReducer(G, void 0, function () {
        return G(m, {
          type: l.init
        });
      }),
      k = A[0],
      H = A[1],
      W = p([].concat(a().useControlledState, [I]), k, {
        instance: s()
      });
    Object.assign(s(), {
      state: W,
      dispatch: H
    });
    var z = t.useMemo(function () {
      return S(p(a().columns, v, {
        instance: s()
      }));
    }, [a, s, v].concat(p(a().columnsDeps, [], {
      instance: s()
    })));
    s().columns = z;
    var T = t.useMemo(function () {
      return p(a().allColumns, C(z), {
        instance: s()
      }).map(x);
    }, [z, a, s].concat(p(a().allColumnsDeps, [], {
      instance: s()
    })));
    s().allColumns = T;
    var O = t.useMemo(function () {
        for (var e = [], t = [], n = {}, o = [].concat(T); o.length;) {
          var r = o.shift();
          le({
            data: d,
            rows: e,
            flatRows: t,
            rowsById: n,
            column: r,
            getRowId: b,
            getSubRows: w,
            accessValueHooks: a().accessValue,
            getInstance: s
          });
        }
        return [e, t, n];
      }, [T, d, b, w, a, s]),
      M = O[0],
      j = O[1],
      L = O[2];
    Object.assign(s(), {
      rows: M,
      initialRows: [].concat(M),
      flatRows: j,
      rowsById: L
    }), g(a().useInstanceAfterData, s());
    var N = t.useMemo(function () {
      return p(a().visibleColumns, T, {
        instance: s()
      }).map(function (e) {
        return P(e, y);
      });
    }, [a, T, s, y].concat(p(a().visibleColumnsDeps, [], {
      instance: s()
    })));
    T = t.useMemo(function () {
      var e = [].concat(N);
      return T.forEach(function (t) {
        e.find(function (e) {
          return e.id === t.id;
        }) || e.push(t);
      }), e;
    }, [T, N]), s().allColumns = T;
    var D = t.useMemo(function () {
      return p(a().headerGroups, B(N, y), s());
    }, [a, N, y, s].concat(p(a().headerGroupsDeps, [], {
      instance: s()
    })));
    s().headerGroups = D;
    var V = t.useMemo(function () {
      return D.length ? D[0].headers : [];
    }, [D]);
    s().headers = V, s().flatHeaders = D.reduce(function (e, t) {
      return [].concat(e, t.headers);
    }, []), g(a().useInstanceBeforeDimensions, s());
    var _ = N.filter(function (e) {
      return e.isVisible;
    }).map(function (e) {
      return e.id;
    }).sort().join("_");
    N = t.useMemo(function () {
      return N.filter(function (e) {
        return e.isVisible;
      });
    }, [N, _]), s().visibleColumns = N;
    var X = ue(V),
      U = X[0],
      $ = X[1],
      J = X[2];
    return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function (e) {
      e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
        instance: s(),
        column: e
      }), e.getFooterProps = f(a().getFooterProps, {
        instance: s(),
        column: e
      });
    }), s().headerGroups = t.useMemo(function () {
      return D.filter(function (e, t) {
        return e.headers = e.headers.filter(function (e) {
          return e.headers ? function e(t) {
            return t.filter(function (t) {
              return t.headers ? e(t.headers) : t.isVisible;
            }).length;
          }(e.headers) : e.isVisible;
        }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
          instance: s(),
          headerGroup: e,
          index: t
        }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
          instance: s(),
          headerGroup: e,
          index: t
        }), !0);
      });
    }, [D, s, a]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function (e) {
      e.getRowProps = f(a().getRowProps, {
        instance: s(),
        row: e
      }), e.allCells = T.map(function (t) {
        var n = e.values[t.id],
          o = {
            column: t,
            row: e,
            value: n
          };
        return o.getCellProps = f(a().getCellProps, {
          instance: s(),
          cell: o
        }), o.render = R(s(), t, {
          row: e,
          cell: o,
          value: n
        }), o;
      }), e.cells = N.map(function (t) {
        return e.allCells.find(function (e) {
          return e.column.id === t.id;
        });
      }), g(a().prepareRow, e, {
        instance: s()
      });
    }, [a, s, T, N]), s().getTableProps = f(a().getTableProps, {
      instance: s()
    }), s().getTableBodyProps = f(a().getTableBodyProps, {
      instance: s()
    }), g(a().useFinalInstance, s()), s();
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});